import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import Button from 'partial/components/Button';
import { useDeleteMaskName } from '../hooks';

export const useOpenDeleteMaskName = () => {
  const createModal = useCreateModal();

  const openDeleteMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <DeleteMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openDeleteMaskNameModal;
};

function DeleteMaskName({ onClose, data }) {
  const [isLoading, remove] = useDeleteMaskName(onClose);

  const submit = () => {
    remove(data?.uuid);
  };

  return (
    <ModalCard size="sm" title="CONFIRM DELETION" onClose={onClose}>
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to remove this mask name
          <span className="text-primary"> {data?.name}</span> for organization
          <span className="text-primary"> {data?.organization_name}</span>?
        </p>
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading}
            outline
            className="uppercase"
            onClick={submit}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

DeleteMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteMaskName;
